/* Custom dropdown script based on W3Schools tutorial */
document.addEventListener('DOMContentLoaded', function() {
  // Get only the dropdown select element in the contact form
  const contactFormSelects = document.querySelectorAll('#ContactForm-enquiry');
  
  // Loop through each select element
  contactFormSelects.forEach(function(select) {
    // Create a custom select wrapper div
    const customSelectDiv = document.createElement('DIV');
    customSelectDiv.setAttribute('class', 'custom-select-wrapper');
    
    // Insert the custom select wrapper before the select element
    select.parentNode.insertBefore(customSelectDiv, select);
    
    // Move the select element inside the wrapper
    customSelectDiv.appendChild(select);
    
    // Create a div that will act as the selected item
    const selectedItemDiv = document.createElement('DIV');
    selectedItemDiv.setAttribute('class', 'select-selected');
    selectedItemDiv.innerHTML = select.options[select.selectedIndex].innerHTML;
    customSelectDiv.appendChild(selectedItemDiv);
    
    // Create a div that will contain the option list
    const optionsListDiv = document.createElement('DIV');
    optionsListDiv.setAttribute('class', 'select-items select-hide');
    
    // For each option in the original select element
    for (let j = 0; j < select.length; j++) {
      // Create a div for each option
      const optionDiv = document.createElement('DIV');
      optionDiv.innerHTML = select.options[j].innerHTML;
      
      // When an item is clicked, update the original select box and the selected item
      optionDiv.addEventListener('click', function(e) {
        // Update the original select box
        const originalSelect = this.parentNode.parentNode.getElementsByTagName('select')[0];
        const selectedDiv = this.parentNode.previousSibling;
        
        for (let i = 0; i < originalSelect.length; i++) {
          if (originalSelect.options[i].innerHTML === this.innerHTML) {
            originalSelect.selectedIndex = i;
            selectedDiv.innerHTML = this.innerHTML;
            
            // Mark this option as selected
            const sameAsSelected = this.parentNode.getElementsByClassName('same-as-selected');
            for (let k = 0; k < sameAsSelected.length; k++) {
              sameAsSelected[k].removeAttribute('class');
            }
            this.setAttribute('class', 'same-as-selected');
            break;
          }
        }
        
        // Simulate a click on the select element to trigger any event listeners
        selectedDiv.click();
      });
      
      optionsListDiv.appendChild(optionDiv);
    }
    
    customSelectDiv.appendChild(optionsListDiv);
    
    // When the selected item is clicked, toggle the options list
    selectedItemDiv.addEventListener('click', function(e) {
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle('select-hide');
      this.classList.toggle('select-arrow-active');
    });
  });
  
  // Close all select boxes except the current one
  function closeAllSelect(elmnt) {
    const selectItems = document.getElementsByClassName('select-items');
    const selectSelected = document.getElementsByClassName('select-selected');
    
    for (let i = 0; i < selectSelected.length; i++) {
      if (elmnt !== selectSelected[i]) {
        selectSelected[i].classList.remove('select-arrow-active');
      }
    }
    
    for (let i = 0; i < selectItems.length; i++) {
      if (elmnt !== selectItems[i].previousSibling) {
        selectItems[i].classList.add('select-hide');
      }
    }
  }
  
  // Close all select boxes when clicking elsewhere on the document
  document.addEventListener('click', closeAllSelect);
});
